import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["tabindex", "onKeydown"]
const _hoisted_2 = ["onKeydown"]
const _hoisted_3 = ["onKeydown"]
const _hoisted_4 = ["onKeydown"]

import { computed, nextTick, ref } from 'vue'

/* 계약서 날짜 — 평소에는 「　　년　　월　　일」 텍스트, 누르면 년·월(·일) 입력 */

export default /*@__PURE__*/_defineComponent({
  __name: 'ScEditDate',
  props: {
    y: {},
    m: {},
    d: { default: '' },
    type: { default: 'ymd' },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:y", "update:m", "update:d"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const active = ref(false)
const dy = ref('')
const dm = ref('')
const dd = ref('')
const yearEl = ref<HTMLInputElement | null>(null)

const text = computed(() => {
  const y = String(props.y || '').trim()
  const m = String(props.m || '').trim()
  const d = String(props.d || '').trim()
  const bw = (v: string, n: number) => (v || '　'.repeat(Math.min(n, 8)))
  if (props.type === 'ym') {
    if (!y && !m) return '　　년　　월'
    return `${bw(y, 4)}년 ${bw(m, 2)}월`
  }
  if (!y && !m && !d) return '　　년　　월　　일'
  return `${bw(y, 4)}년 ${bw(m, 2)}월 ${bw(d, 2)}일`
})

function activate() {
  if (props.disabled) return
  dy.value = String(props.y || '')
  dm.value = String(props.m || '')
  dd.value = String(props.d || '')
  active.value = true
  nextTick(() => yearEl.value?.focus())
}

function commit() {
  if (!active.value) return
  active.value = false
  const y = dy.value.trim()
  const m = dm.value.trim()
  const d = dd.value.trim()
  if (y !== String(props.y || '')) emit('update:y', y)
  if (m !== String(props.m || '')) emit('update:m', m)
  if (props.type === 'ymd' && d !== String(props.d || '')) emit('update:d', d)
}

function cancel() {
  active.value = false
}

function onFocusOut(e: FocusEvent) {
  const next = e.relatedTarget as Node | null
  if (next && (e.currentTarget as HTMLElement).contains(next)) return
  commit()
}

return (_ctx: any,_cache: any) => {
  return (!active.value)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["sc-edit sc-edit--date", { 'is-disabled': __props.disabled }]),
        role: "button",
        tabindex: __props.disabled ? -1 : 0,
        onClick: activate,
        onKeydown: _withKeys(_withModifiers(activate, ["prevent"]), ["enter"])
      }, _toDisplayString(text.value), 43, _hoisted_1))
    : (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: "sc-edit-group",
        onFocusout: onFocusOut
      }, [
        _withDirectives(_createElementVNode("input", {
          ref_key: "yearEl",
          ref: yearEl,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dy).value = $event)),
          class: "sc-edit-input sc-edit-input--y",
          inputmode: "numeric",
          "aria-label": "년",
          onKeydown: [
            _withKeys(_withModifiers(commit, ["prevent"]), ["enter"]),
            _withKeys(_withModifiers(cancel, ["prevent"]), ["esc"])
          ]
        }, null, 40, _hoisted_2), [
          [_vModelText, dy.value]
        ]),
        _cache[4] || (_cache[4] = _createTextVNode("년 ", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dm).value = $event)),
          class: "sc-edit-input sc-edit-input--m",
          inputmode: "numeric",
          "aria-label": "월",
          onKeydown: [
            _withKeys(_withModifiers(commit, ["prevent"]), ["enter"]),
            _withKeys(_withModifiers(cancel, ["prevent"]), ["esc"])
          ]
        }, null, 40, _hoisted_3), [
          [_vModelText, dm.value]
        ]),
        _cache[5] || (_cache[5] = _createTextVNode("월 ", -1)),
        (__props.type === 'ymd')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dd).value = $event)),
                class: "sc-edit-input sc-edit-input--d",
                inputmode: "numeric",
                "aria-label": "일",
                onKeydown: [
                  _withKeys(_withModifiers(commit, ["prevent"]), ["enter"]),
                  _withKeys(_withModifiers(cancel, ["prevent"]), ["esc"])
                ]
              }, null, 40, _hoisted_4), [
                [_vModelText, dd.value]
              ]),
              _cache[3] || (_cache[3] = _createTextVNode("일 ", -1))
            ], 64))
          : _createCommentVNode("", true)
      ], 32))
}
}

})